import type { Business } from '@/modules/dashboard/dashboardTypes';
import { DropDownGold } from '@/resources/assets/images';
import { useState } from 'react';

type WorkingHoursSessionProps = Pick<Business, 'hours'>;

export const WorkingHoursSession = ({ hours }: WorkingHoursSessionProps) => {
	const dayMap = {
		M: 'Monday',
		T: 'Tuesday',
		W: 'Wednesday',
		Th: 'Thursday',
		F: 'Friday',
		Sa: 'Saturday',
		Su: 'Sunday'
	};

	const hasHours = hours && Object.keys(dayMap).some(dayKey => hours[dayKey]);

	const [showWorkingHours, setShowWorkingHours] = useState(false);

	if (!hasHours) return null;

	const handleToggleHoursDropdown = () => {
		setShowWorkingHours(state => !state);
	};

	return (
		<div className="flex w-full flex-col items-start gap-2">
			<button
				type="button"
				className="inline-block cursor-pointer pr-2.5 align-top text-sm font-medium text-dm-white transition-opacity duration-200 ease-in-out hover:opacity-70"
				onClick={handleToggleHoursDropdown}
			>
				<strong className="flex items-center font-semibold text-dm-mid-grey">
					See all location hours{' '}
					<DropDownGold
						data-show-more={showWorkingHours}
						className="inline-block rotate-180 align-top text-dm-gold transition-transform duration-200 ease-in-out data-[show-more=true]:rotate-0"
					/>
				</strong>
			</button>

			<ul
				data-show-more={showWorkingHours}
				className="flex w-full max-w-56 flex-col gap-2"
			>
				{Object.entries(dayMap).map(([key, label]) => {
					const dayhours = hours[key];

					if (!dayhours) return null;

					return (
						<li
							key={key}
							data-is-showing-working-hours={showWorkingHours}
							className="relative grid w-full grid-cols-2 items-center font-medium text-dm-white [&[data-is-showing-working-hours=false]:not(:first-of-type)]:hidden"
						>
							<span className="text-dm-mid-grey">{label}</span>

							<span className="w-full whitespace-nowrap">
								{dayhours}
							</span>
						</li>
					);
				})}
			</ul>
		</div>
	);
};
